import { createContext } from "react";

import type { ITransactionItem } from "@/src/cashback/MainPage/Transactions/shared";

export type TransactionsContextState = {
    claim: (item: ITransactionItem) => void;
};

export const TransactionsContext = createContext<TransactionsContextState>({
    claim: () => {},
});
